import { apiClient } from "../../../api/client";
import * as ActionType from "./fakeSeller.type";
import { setToast } from "../../../util/toast";

export const getFakeSeller = (start, limit) => async (dispatch) => {
  const res = await apiClient.get(`seller/getFakeSeller?start=${start}&limit=${limit}`);
  if (res.ok) {
    dispatch({
      type: ActionType.GET_FAKE_SELLER,
      payload: res.data?.sellers,
      totalSellers: res.data?.totalSellers,
    });
  } else {
    console.error(res.message);
  }
};

export const getFakeSellerDropDown = () => async (dispatch) => {
  const res = await apiClient.get("seller/fakeSellers");
  if (res.ok) {
    dispatch({
      type: ActionType.GET_FAKE_SELLER_NAME,
      payload: res.data?.seller,
    });
  } else {
    console.error(res.message);
  }
};

export const createFakeSeller = (formData) => async (dispatch) => {
  const res = await apiClient.post("seller/createFakeSeller", formData);
  if (res.ok && res.data?.status === true) {
    dispatch({
      type: ActionType.CREATE_FAKE_SELLER,
      payload: res.data.sellerData,
    });
    setToast("success", "Fake Seller created Successfully !");
  } else if (!res.ok) {
    setToast("error", res.message);
  }
};

export const updateFakeSeller = (formData, id) => async (dispatch) => {
  const res = await apiClient.patch(
    `seller/updateFakeSellerProfile?sellerId=${id}`,
    formData
  );
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_FAKE_SELLER,
      payload: { updateSeller: res.data.seller, id },
    });

    setToast("success", "Fake Seller Updated Successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const deleteFakeSeller = (id) => async (dispatch) => {
  const res = await apiClient.delete(`seller/deleteSeller?sellerId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.DELETE_FAKE_SELLER,
      payload: id,
    });
    setToast("success", "Fake Seller Delete successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const sellerIsLive = (seller, block) => async (dispatch) => {
  const res = await apiClient.patch(`seller/liveOrNot?sellerId=${seller?._id}`);
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.ISLIVE_FAKE_SELLER,
      payload: { data: res.data.seller, id: seller?._id },
    });
    setToast(
      "success",
      `${seller.firstName}  isLive ${block === true ? "Enable" : "Disable"} Successfully!`
    );
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const getProducts = (sellerId) => async (dispatch) => {
  const res = await apiClient.get(
    `liveSeller/retrieveProductList?sellerId=${sellerId}`
  );
  if (res.ok) {
    dispatch({
      type: ActionType.GET_PRODUCTS,
      payload: res.data?.data ?? res.data,
    });
  } else {
    console.error(res.message);
  }
};

export const selectProducts = (data) => async (dispatch) => {
  const res = await apiClient.post("liveSeller/setSellerLiveWithProducts", data);
  if (res.ok && res.data?.status === true) {
    dispatch({
      type: ActionType.IS_LIVE_SELLER,
      payload: { data: res.data.data, id: data?.sellerId },
    });
    setToast("success", res.data.message);
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const setOfflineStatus = (id) => async (dispatch) => {
  const res = await apiClient.patch(
    `liveSeller/setSellerOfflineAndResetProducts?sellerId=${id}`
  );

  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.IS_OFFLINE,
      payload: { data: res.data.data, id },
    });
    setToast("success", res.data.message);
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
